
import React, { Component } from "react";
import { Tabs, Tab } from "react-bootstrap";

import { connect } from "react-redux";
import ComponentHeader from "../common/ComponentHeader";
import { getAllSubscriptionApi, getAllBannerApi } from './Api';
import { API_LIMIT, START_PAGE } from "../../utils/Constant";
import PremimumPlanTab from "./PremimumPlanTab";
import PremimumPlanForm from "./PremimumPlanForm";
import { withRouter } from "../../utils/hoc/withRouter";
class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      dataList: [],
      totalPages: null,
      activeTab: {
        tabName: "Premium-Plan",
        eventKey: "premium-plan",
        primaryBtn: "Add premium-plan",
        searchPlaceholder: "Search premium-plan",
        api: this.props.getAllSubscriptionApi,
        componentName: <PremimumPlanTab {...this.props} />,
        showAddEdit: false,
        addEditModal: (
          <PremimumPlanForm show={true} onHide={this.handlePrimaryBtn} ctx={this} />
        ),
      },
      tabArray: [
        {
          tabName: "Premium-Plan",
          eventKey: "premium-plan",
          primaryBtn: "Add premium-plan",
          searchPlaceholder: "Search premium-plan",
          api: this.props.getAllSubscriptionApi,
          componentName: <PremimumPlanTab {...this.props} />,
          showAddEdit: false,
          addEditModal: (
            <PremimumPlanForm show={true} onHide={this.handlePrimaryBtn} ctx={this} />
          ),
        },

      ]
    };
  }
  handlePrimaryBtn = () => {
    const { activeTab } = this.state;
    this.setState({
      activeTab: {
        ...activeTab,
        showAddEdit: !activeTab.showAddEdit,
      },
    });
    if(activeTab?.tabName==="Premium-Plan"){
      this.props.history({
        pathname:'/premimum-planForm'
      })
    }
  };
  componentDidMount() {
    const { history } = this.props;
    history({
      search: `?tab=${this.state.activeTab.eventKey}&p=${START_PAGE}`,
    });
    this.state.activeTab.api(this);
  }
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevSearch = prevParams.get("search") || "";
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = prevParams.get("pageSize") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";
    const verified = params.get("isVerified") || "";
    const size = params.get("pageSize") || "";

    if (prevPage !== page || prevSearch !== search || prevVerified !== verified || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        if (search) {
          this.state.activeTab.api(this);
        } else {
          this.state.activeTab.api(this);
        }
      });
    }
  }



  handleTabChange = (tab) => {
    let activeTab = this.state.tabArray.filter((item) => item.eventKey === tab);
    this.setState({ activeTab: activeTab[0] });
    this.props.history({
      search: `?tab=${activeTab[0].eventKey}&p=${START_PAGE}`,
    });
    activeTab[0].api(this);
  };

  render() {
    const { search, tabName, activeTab, tabArray } = this.state;

    return (
      <section className="contentCollections-main-frame">
        {activeTab.showAddEdit && activeTab.addEditModal}
        <ComponentHeader
          title="Plans and Subscriptions"
          // primaryBtn={tabName}
          breadcrumb
          primaryBtn={activeTab.primaryBtn}
          // isSearch={true}
          // isBackArrow={true}
          // isReturn="/contentCollections"
          handlePrimaryBtn={this.handlePrimaryBtn}
        // handlePrimaryBtn={() => { this.props.history('/add-content') }}
        />
        <Tabs
          defaultActiveKey={activeTab.eventKey}
          onSelect={this.handleTabChange}
          className="tab-title"
          id="uncontrolled-tab-example"
        >
          {
            tabArray.map((tab) => {
              return (
                <Tab eventKey={tab.eventKey} title={tab.tabName}>
                  {tab.componentName}
                </Tab>
              )
            })
          }
        </Tabs>
      </section>
    );
  }
}


const mapStateToProps = (state) => ({
  contentCollectionsState: state.ContentCollectionsState,
});
const mapDispatchToProps = {
  getAllSubscriptionApi,


};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Subscription));
